export * from './delete-gutachten.component';
export * from './delete-gutachten.component.module';